import React, { Component } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Button from '@material-ui/core/Button';
import api from "../api/backend"

class News extends Component {
    state = { config: {}, news: '' }

    getConfiguration = () => {
        api.getConfiguration().then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ config: json })
            }
        }).catch(() => { })
    }

    componentDidMount() {
        this.getConfiguration()
    }

    render() {
        const { config } = this.state
        return (
            <div style={{ padding: 100 }}>
                <CKEditor
                    disabled={true}
                    config={{ toolbar: [] }}
                    editor={ClassicEditor}
                    data={config.news}
                />
            </div>
        );
    }
}

export default News;